export enum SafetyEventStatuses {
	close = 'close',
	active = 'active',
}

export enum StatusChannels {
	manual = 'manual',
	automatic = 'automatic',
}

export enum NotificationStatuses {
	notSent = 'notSent',
	sent = 'sent',
	sending = 'sending',
}

export enum TagStatuses {
	Storage = 'Storage',
	Sleeping = 'Sleeping',
	Good = 'Good',
	NoReception = 'NoReception',
}
